import React, { useState } from "react";
import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
} from "@mui/material";
import ModalLayout from "src/components/common/Layout/ModalLayout";
import { AntSwitch } from "src/components/ReservationProduct/components/FiltersModal/components/AntSwitch";
import DefaultButton from "src/components/common/Buttons/DefaultButton";
import { Controller, useForm } from "react-hook-form";
import SubmitButton from "src/components/common/Buttons/SubmitButton";
import TuneIcon from "@mui/icons-material/Tune";
import {
  EnumMetrikActions,
  sendCustomYandexMetrik,
} from "src/config/analytics/sendCustomYandexMetrik";

export enum FILTER_OPTION {
  PriceIncrease = "priceIncrease",
  PriceDecrease = "priceDecrease",
  BuyPrice = "buyPrice",
  Price = "price",
}

interface FiltersModalProps {
  onClickFiltersSubmit: (data: FilterModalCheckbox) => void;
  isOpenMap: boolean;
  filterOption: FILTER_OPTION;
  handleSelectChange: (event: SelectChangeEvent) => void;
  setFilterOption: (option: FILTER_OPTION) => void;
}

export interface FilterModalCheckbox {
  underTheOrder: boolean;
  available: boolean;
  aroundTheClock: boolean;
}

const FiltersModal: React.FC<FiltersModalProps> = ({
  onClickFiltersSubmit,
  isOpenMap,
  filterOption,
  handleSelectChange,
  setFilterOption,
}) => {
  const [isOpen, setOpen] = useState(false);

  const { handleSubmit, reset, control } = useForm<FilterModalCheckbox>({
    mode: "onSubmit",
  });

  const onConfirmFilter = (data: FilterModalCheckbox) => {
    onClickFiltersSubmit(data);
    setOpen(false);
  };

  return (
    <>
      <Button
        sx={{ mr: isOpenMap ? 3 : 0 }}
        onClick={() => {
          sendCustomYandexMetrik(
            EnumMetrikActions.clickOnFiltersBtnOnOffersMap
          );
          setOpen(true);
        }}
        variant="outlined"
      >
        <TuneIcon />
      </Button>
      <ModalLayout isOpen={isOpen} onClose={() => setOpen(false)} zIndex={1300}>
        <Box
          onSubmit={handleSubmit(onConfirmFilter)}
          noValidate
          component="form"
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "20px",
            height: "100%",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "start",
              width: "100%",
            }}
          >
            <Box sx={{ flexWrap: "wrap", gap: "10px", display: "flex" }}>
              <Controller
                defaultValue={true}
                name="underTheOrder"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <FormControlLabel
                    control={
                      <AntSwitch
                        color="default"
                        sx={{ mr: 1 }}
                        checked={value}
                        onChange={onChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    }
                    label="Под заказ"
                  />
                )}
              />
              <Controller
                defaultValue={true}
                name="available"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <FormControlLabel
                    control={
                      <AntSwitch
                        color="default"
                        sx={{ mr: 1 }}
                        checked={value}
                        onChange={onChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    }
                    label="В наличии"
                  />
                )}
              />
              <Controller
                defaultValue={false}
                name="aroundTheClock"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <FormControlLabel
                    control={
                      <AntSwitch
                        color="default"
                        sx={{ mr: 1 }}
                        checked={value}
                        onChange={onChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    }
                    label="Круглосуточные аптеки"
                  />
                )}
              />
              <Select
                sx={{
                  marginLeft: "auto",
                  maxHeight: "37px",
                  display: {
                    xs: !isOpenMap ? "none" : "flex",
                    md: isOpenMap ? "flex" : "none",
                  },
                  mt: 1,
                }}
                value={filterOption}
                onChange={handleSelectChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem value={FILTER_OPTION.BuyPrice}>
                  С возможностью заказа, по цене
                </MenuItem>
                <MenuItem value={FILTER_OPTION.Price}>По цене</MenuItem>
              </Select>
            </Box>
            <Divider sx={{ width: "100%", marginTop: "15px" }} />
          </Box>
          <Stack spacing={1}>
            <DefaultButton
              onClick={() => {
                setFilterOption(FILTER_OPTION.BuyPrice);
                reset({
                  underTheOrder: true,
                  aroundTheClock: false,
                  available: true,
                });
              }}
              fontSize="12px"
              sx={{
                width: "260px",
                height: "34px",
                backgroundColor: "transparent",
                ":hover": {
                  backgroundColor: "transparent",
                  opacity: "60%",
                },
              }}
              title="Сбросить"
            />
            <SubmitButton
              type="submit"
              sx={{
                width: "260px",
                height: "34px",
              }}
              title="Применить"
            />
          </Stack>
        </Box>
      </ModalLayout>
    </>
  );
};

export default FiltersModal;
